import { faScrewdriverWrench } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Divider, Input, message, Popconfirm, Typography } from "antd";
import { useState } from "react";
import TestAdminService from "../services/TestAdmin/TestAdminService";

const { Title, Paragraph } = Typography;

const TestingPage = () => {
  const [containerNum, setContainerNum] = useState("");
  const [containerNumBL, setContainerNumBL] = useState("");
  const [blNum, setBLNum] = useState("");
  const [sealine, setSealine] = useState("");

  const handleAction = (action, successMsg) => {
    try {
      action();
      message.success(successMsg);
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message || "An unexpected error occurred");
    }
  };

  return (
    <div className="p-6">
      <Title
        level={2}
        className="text-center mb-2 flex items-center justify-center gap-2"
      >
        <FontAwesomeIcon
          icon={faScrewdriverWrench}
          className="text-blue-500 text-2xl"
        />
        Admin Testing
      </Title>

      <Divider />

      <div className="flex flex-wrap justify-center gap-8">
        {/* Refetch Data Scheduler */}
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Refetch Data Scheduler</Title>
            <Paragraph>Run the SeaRates data refetch scheduler.</Paragraph>
          </div>
          <Popconfirm
            title="Are you sure to run SeaRates refetch data scheduler?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.runRefetchDataScheduler(),
                "Refetch Scheduler Started"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap"
              block
            >
              Run Refetch Scheduler
            </Button>
          </Popconfirm>
        </Card>

        {/* Retry Failure Scheduler */}
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-red-100 to-red-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Retry Failure Scheduler</Title>
            <Paragraph>Run the SeaRates retry failure scheduler.</Paragraph>
          </div>
          <Popconfirm
            title="Are you sure to run SeaRates retry failure scheduler?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.runRetryFailureScheduler(),
                "Retry Failure Scheduler Started"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap"
              block
            >
              Run Failure Scheduler
            </Button>
          </Popconfirm>
        </Card>

        {/* SeaRates Tracking By CT */}
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-green-100 to-green-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Track by CT</Title>
            <Paragraph>Track data using container number.</Paragraph>
          </div>
          <Input
            placeholder="Enter container number"
            value={containerNum}
            onChange={(e) => setContainerNum(e.target.value)}
            className="mb-2"
          />
          <Popconfirm
            title="Are you sure to start SeaRates tracking for this container?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.startSeaRatesTrackingByCT(containerNum),
                "Searates Call Started"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap mt-2"
              block
              disabled={!containerNum.trim()}
            >
              Run SeaRates Tracking
            </Button>
          </Popconfirm>
        </Card>

        {/* SeaRates Tracking By BL */}
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-orange-100 to-orange-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Track by BL</Title>
            <Paragraph>Track data using BL number and sealine.</Paragraph>
          </div>
          <Input
            placeholder="Enter container number"
            value={containerNumBL}
            onChange={(e) => setContainerNumBL(e.target.value)}
            className="mb-2"
          />
          <Input
            placeholder="Enter BL number"
            value={blNum}
            onChange={(e) => setBLNum(e.target.value)}
            className="mb-2"
          />
          <Input
            placeholder="Enter sealine code"
            value={sealine}
            onChange={(e) => setSealine(e.target.value)}
            className="mb-2"
          />
          <Popconfirm
            title="Are you sure to start SeaRates tracking for this?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.startSearatesTrackingByBL(containerNumBL, blNum, sealine),
                "Tracking by BL Started"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap mt-2"
              block
              disabled={!containerNumBL.trim() || !blNum.trim() || !sealine.trim()}
            >
              Run SeaRates Tracking
            </Button>
          </Popconfirm>
        </Card>

        {/* Read OneStop Emails */}
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-purple-100 to-purple-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Read OneStop Emails</Title>
            <Paragraph>Start reading the unread emails from OneStop.</Paragraph>
          </div>
          <Popconfirm
            title="Are you sure to start reading OneStop emails?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.readOneStopEmails(),
                "Started Reading OneStop Emails"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap"
              block
            >
              Read OneStop Emails
            </Button>
          </Popconfirm>
        </Card>

        {/*
        Copy Blob Container Data
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-orange-100 to-orange-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Copy Blob Container Data</Title>
            <Paragraph>Start copying the container data from source to destination.</Paragraph>
          </div>
          <Input
            placeholder="Enter source container"
            value={copySource}
            onChange={(e) => setCopySource(e.target.value)}
            className="mb-2"
          />
          <Input
            placeholder="Enter destination container"
            value={copyDest}
            onChange={(e) => setCopyDest(e.target.value)}
            className="mb-2"
          />
          <Popconfirm
            title="Are you sure to start copying the blob container data?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.copyBlobContainerData(copySource, copyDest),
                "Started Copying Blob Container Data"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap mt-2"
              block
              disabled={!copySource.trim() || !copyDest.trim()}
            >
              Start Copying Container
            </Button>
          </Popconfirm>
        </Card>

        Move Blob Container Data
        <Card
          hoverable
          className="rounded-xl bg-gradient-to-br from-orange-100 to-orange-200 flex flex-col justify-between shadow-lg w-[280px] h-[320px]"
        >
          <div>
            <Title level={4} className="mt-3">Move Blob Container Data</Title>
            <Paragraph>Start moving the container data from source to destination.</Paragraph>
          </div>
          <Input
            placeholder="Enter source container"
            value={moveSource}
            onChange={(e) => setMoveSource(e.target.value)}
            className="mb-2"
          />
          <Input
            placeholder="Enter destination container"
            value={moveDest}
            onChange={(e) => setMoveDest(e.target.value)}
            className="mb-2"
          />
          <Popconfirm
            title="Are you sure to start moving the blob container data?"
            placement="bottom"
            okText="Yes"
            cancelText="No"
            onConfirm={() =>
              handleAction(
                () => TestAdminService.moveBlobContainerData(moveSource, moveDest),
                "Started Moving Blob Container Data"
              )
            }
          >
            <Button
              type="primary"
              className="text-sm whitespace-nowrap mt-2"
              block
              disabled={!moveSource.trim() || !moveDest.trim()}
            >
              Start Moving Container
            </Button>
          </Popconfirm>
        </Card>
        */}
      </div>
    </div>
  );
};

export default TestingPage;